import { isTeamBiDirectionalEnabled as getIsTeamBiDirectionalEnabled } from '../../../../common/utils/utils';
import { useTeamSelectorContext } from '../../../../controllers/team-selector-context';

export const useTeamBiDirectionalExp = () => {
	const { containerType } = useTeamSelectorContext();
	const isTeamBiDirectionalEnabled = getIsTeamBiDirectionalEnabled(containerType);

	return {
		isTeamBiDirectionalEnabled,
	};
};
